// extracted by mini-css-extract-plugin
module.exports = {"container":"swatch_container__z3Mne","hidden":"swatch_hidden__FQqA1","header":"swatch_header__3oXcY","finalSale":"swatch_finalSale__bBKir","title":"swatch_title__DNfH_"};